import { TWebsiteBuilderNormalizeTraverse } from "../../schema/normalization/websiteBuilderNormalizeEditor";
import { TWebsiteBuilderElement, websiteBuilderElementValid } from "../element/websiteBuilderElement";
import { IWebsiteBuilderNodeBase, IWebsiteBuilderNodeDesignStyles, TWebsiteBuilderNode } from "../websiteBuilderNode";

type TWebsiteBuilderGridCellEmptyChildren = [];
type TWebsiteBuilderGridCellFilledChildren = [TWebsiteBuilderElement];

type TWebsiteBuilderGridCellChildren =
  | TWebsiteBuilderGridCellEmptyChildren
  | TWebsiteBuilderGridCellFilledChildren;

export interface IWebsiteBuilderGridCell extends IWebsiteBuilderNodeBase {
  type: "grid-cell";
  children: TWebsiteBuilderGridCellChildren;
}

export function isWebsiteBuilderGridCell(node: TWebsiteBuilderNode): node is IWebsiteBuilderGridCell {
  return node?.type === "grid-cell";
}

export function websiteBuilderGridCellFilled(node: IWebsiteBuilderGridCell): node is IWebsiteBuilderGridCell & {
  children: TWebsiteBuilderGridCellFilledChildren;
} {
  return node?.children?.length === 1;
}

export function websiteBuilderGridCellValid(node: any): node is IWebsiteBuilderGridCell {
  const partialNode: Partial<IWebsiteBuilderGridCell> = node;

  return (
    partialNode != null &&
    partialNode.id != null &&
    partialNode.type === "grid-cell"
  );
}

export function websiteBuilderGenerateDefaultGridCell(): IWebsiteBuilderGridCell {
  return {
    id: crypto.randomUUID(),
    type: "grid-cell",
    children: [],
  };
}

export function websiteBuilderNormalizeValidGridCell(
  node: IWebsiteBuilderGridCell,
  normalizeTraverse: TWebsiteBuilderNormalizeTraverse,
): IWebsiteBuilderGridCell {
  let children: TWebsiteBuilderGridCellChildren = [];

  if (websiteBuilderGridCellFilled(node) && websiteBuilderElementValid(node.children[0])) {
    children = [normalizeTraverse(node.children[0])];
  }

  const normalizedGridCell: IWebsiteBuilderGridCell = {
    id: node.id,
    type: node.type,
    children,
  };

  return normalizedGridCell;
}

export function websiteBuilderGenerateGridCellDesignStyles(): IWebsiteBuilderNodeDesignStyles {
  return {
    className: "website-builder-grid-cell",
    styleProperties: {},
    styleDeclaration: "",
  };
}